import { render, staticRenderFns } from "./noticeModfiyPage.vue?vue&type=template&id=6ca1c806&scoped=true&"
import script from "./noticeModfiyPage.vue?vue&type=script&lang=js&"
export * from "./noticeModfiyPage.vue?vue&type=script&lang=js&"
import style0 from "./noticeModfiyPage.vue?vue&type=style&index=0&id=6ca1c806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca1c806",
  null
  
)

export default component.exports